import React from 'react';
import { motion } from 'framer-motion';

const Logo = ({ size = 40, showText = true }) => {
  return (
    <motion.div 
      className="flex items-center gap-3"
      whileHover={{ scale: 1.02 }}
      transition={{ type: "spring", stiffness: 400 }}
    >
      <div className="relative flex items-center justify-center" style={{ width: size, height: size }}>
        <motion.div
          className="absolute inset-0"
          style={{ filter: 'blur(10px)', opacity: 0.5 }}
          animate={{ scale: [1, 1.15, 1], opacity: [0.4, 0.7, 0.4] }}
          transition={{ duration: 3, repeat: Infinity }}
        >
          <svg viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg" width={size} height={size}>
            <path d="M25 4C14 8 6 18 6 30c0 12 8 22 19 26C18 52 12 42 12 30S18 8 25 4z" fill="url(#lg1)"/>
            <path d="M35 4c11 4 19 14 19 26 0 12-8 22-19 26 7-4 13-14 13-26S42 8 35 4z" fill="url(#lg2)"/>
            <defs>
              <linearGradient id="lg1" x1="6" y1="4" x2="25" y2="56" gradientUnits="userSpaceOnUse">
                <stop stopColor="#8B5CF6"/><stop offset="1" stopColor="#0047FF"/>
              </linearGradient>
              <linearGradient id="lg2" x1="35" y1="4" x2="54" y2="56" gradientUnits="userSpaceOnUse">
                <stop stopColor="#00E5FF"/><stop offset="1" stopColor="#0047FF"/>
              </linearGradient>
            </defs>
          </svg>
        </motion.div>
        <svg viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg" width={size} height={size} className="relative z-10">
          <path d="M25 4C14 8 6 18 6 30c0 12 8 22 19 26C18 52 12 42 12 30S18 8 25 4z" fill="url(#g1)"/>
          <path d="M35 4c11 4 19 14 19 26 0 12-8 22-19 26 7-4 13-14 13-26S42 8 35 4z" fill="url(#g2)"/>
          <path d="M30 16l-6 10h12l-6 10" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
          <path d="M26 36l4 8 4-8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" opacity="0.7"/>
          <defs>
            <linearGradient id="g1" x1="6" y1="4" x2="25" y2="56" gradientUnits="userSpaceOnUse">
              <stop stopColor="#8B5CF6"/><stop offset="1" stopColor="#0047FF"/>
            </linearGradient>
            <linearGradient id="g2" x1="35" y1="4" x2="54" y2="56" gradientUnits="userSpaceOnUse">
              <stop stopColor="#00E5FF"/><stop offset="1" stopColor="#0047FF"/>
            </linearGradient>
          </defs>
        </svg>
      </div>
      
      {showText && (
        <span 
          className="font-bold text-xl tracking-tight"
          style={{ fontFamily: "'Unbounded', sans-serif" }}
        >
          <span className="text-[var(--text-primary)]">DeFi</span>
          <span className="bg-gradient-to-r from-[#0047FF] to-[#00E5FF] bg-clip-text text-transparent">Bot</span>
        </span>
      )}
    </motion.div>
  );
};

export default Logo;
